import React from "react";
import { useCareRecipientInformation } from "../../../../hooks/care_recipient/useCareRecipientInformation";
import { CareRecipientIcon } from "../../../common/icons/CareRecipientIcon";

export const CareRecipientInformation = React.memo(function CareRecipientInformation() {
    const careRecipientInformation = useCareRecipientInformation();

    return (
        <div className={"recipient_container"}>
            {careRecipientInformation ? (
                <div className={"recipient_info"}>
                    <div className="icon">
                        <CareRecipientIcon careRecipientId={careRecipientInformation.id}/>
                    </div>
                    <div className="content">
                        <div className="name">{careRecipientInformation.name.value}</div>
                        <div className="sub_content">
                            <div className="label">生年月日：</div>
                            <div className="value">
                                {careRecipientInformation.birthday && `${careRecipientInformation.birthday.year}年${careRecipientInformation.birthday.month}月${careRecipientInformation.birthday.date}日`}
                            </div>
                        </div>
                    </div>
                </div>
            ) : <></>}
        </div>
    );
});
